import stores from '@/storage/stores'
import { ref } from 'vue'

export const categoryBus = ref(stores.getStoresData().category)
